import listSaga from './listSaga'

const eventTypeSagas = [listSaga()]

export default eventTypeSagas
